import { GetterTree, Getter } from "vuex";
import { RootState } from "@/store/types";
import ReservationState from "./types";

export const getters: GetterTree<ReservationState, RootState> =
{
};